import { Actions, thunk } from 'easy-peasy';
import api from '~/services/api';
import { IThunkRestoreMedication, IClientDetailsStore, IClientDetailsActions } from '../types';

const onRestoreMedication: IThunkRestoreMedication = thunk(
  async ({ setClientDetails }: Actions<IClientDetailsActions>, payload, { getState }) => {
    const localState = getState() as IClientDetailsStore;

    await api.clientDetails.restoreMedication(payload);

    const medications = localState.medications.map(item =>
      item.id !== Number(payload.id) ? item : { ...item, isArchived: false },
    );

    setClientDetails({ medications });
  },
);

export default onRestoreMedication;
